import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/autoplay';
import Lottie from 'lottie-react';
import { useState, useEffect } from 'react';
import Animation_A from '../Assets/Animation - 1738740396932.json';
import Animation_B from '../Assets/Animation - 1738740567782.json';
import Animation_C from '../Assets/Animation - 1738740697060.json';
import '../CSS/Carousel.css'; 

export default function Carousel() {
    const projects = [
        { animation: Animation_A },
        { animation: Animation_B },
        { animation: Animation_C },
    ];

    const [timer, setTimer] = useState(40 * 60 * 60);

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer(prevTime => (prevTime > 0 ? prevTime - 1 : 40 * 60 * 60));
        }, 1000);
        return () => clearInterval(countdown);
    }, []);

    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;
        return `${hours}h ${minutes}m ${seconds}s`;
    };

    return (
        <section id='carousel' className="carousel-section bg-dark text-white ">
            <div className="container">
                <div className="row mx-1">
                    <div className="col-md-7 text-content d-none d-lg-block my-lg-5">
                        <strong className="text-uppercase text-warning" style={{ fontSize: '1.2rem', letterSpacing: '1px' }}>Rayan Software Solutions</strong>
                        <h2 className="display-4 font-weight-bold mt-2" style={{ fontFamily: 'Poppins, sans-serif' }}>Empower Your Business with Cutting-Edge Technology</h2>
                        <p className="lead" style={{ fontSize: '1.1rem', fontFamily: 'Roboto, sans-serif' }}>
                            Empowering businesses with smart, scalable software solutions. From CRM integration to enterprise automation, we streamline operations and enhance customer engagement. 🚀
                        </p>
                        <div className="d-flex align-items-center mt-4">
                            <button className="btn btn-light text-primary px-4 py-2 fw-bold me-3" onClick={() => document.getElementById("ContactUs").scrollIntoView({ behavior: "smooth" })} style={{ borderRadius: '10px', fontSize: '1.1rem' }}>Get a Demo</button>
                            <button className="btn btn-warning text-dark px-4 py-2 fw-bold" style={{ fontSize: '1.1rem', borderRadius: '10px' }}>Offer ends in: {formatTime(timer)}s</button>
                        </div>              
                    </div>
                    <div className="col-12 d-block d-lg-none my-3">
                        <strong className="text-uppercase text-warning" style={{ fontSize: '1.2rem', letterSpacing: '1px' }}>Rayan Software Solutions</strong>            
                    </div>
                    <div className="col-sm-7 d-none d-sm-block d-lg-none mb-3">
                        <p className="lead" style={{ fontSize: '1.1rem', fontFamily: 'Roboto, sans-serif' }}>
                            Empowering businesses with smart, scalable software solutions. From CRM integration to enterprise automation, we streamline operations and enhance customer engagement. 🚀
                        </p>
                        <div className="d-lg-flex align-items-center mt-4">
                            <button className="btn btn-light text-primary px-4 py-2 fw-bold me-3 mb-sm-2" onClick={() => document.getElementById("ContactUs").scrollIntoView({ behavior: "smooth" })} style={{ borderRadius: '10px', fontSize: '1.1rem' }}>Get a Demo</button>
                            <button className="btn btn-warning text-dark px-4 py-2 fw-bold" style={{ fontSize: '1.1rem', borderRadius: '10px' }}>Offer ends in: {formatTime(timer)}s</button>
                        </div>         
                    </div>
                    <div className="col-12 d-block d-sm-none mb-1">
                        <h2 className="display-6 font-weight-bold mt-2" style={{ fontFamily: 'Poppins, sans-serif' }}>Empower Your Business with Cutting-Edge Technology</h2>       
                    </div>
                    <div className="col-12 d-flex d-sm-none justify-content-center">
                        <Swiper effect={'coverflow'} grabCursor={true} centeredSlides={true} slidesPerView={'auto'}
                            coverflowEffect={{ rotate: 30, stretch: 0, depth: 100, modifier: 1, slideShadows: false }}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            modules={[EffectCoverflow, Autoplay]} className="w-full max-w-4xl mx-auto">
                            {projects.map((project, index) => (
                                <SwiperSlide key={index}>
                                    <Lottie animationData={project.animation} loop={true} autoplay={true} style={{ width: '100%', height: 'auto'}} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    <div className="col-12 d-block d-sm-none mb-3"> 
                        <p className="lead" style={{ fontSize: '1.1rem', fontFamily: 'Roboto, sans-serif' }}>
                            Empowering businesses with smart, scalable software solutions. From CRM integration to enterprise automation, we streamline operations and enhance customer engagement. 🚀
                        </p> 
                        <div className="d-flex align-items-center mt-4">
                            <button className="btn btn-light text-primary px-3 py-2 fw-bold me-3" onClick={() => document.getElementById("ContactUs").scrollIntoView({ behavior: "smooth" })} style={{ borderRadius: '10px', fontSize: '1.1rem' }}>Get a Demo</button>
                            <button className="btn btn-warning text-dark px-3 py-2 fw-bold" style={{ fontSize: '1.1rem', borderRadius: '10px' }}>Offer ends in: {formatTime(timer)}s</button>
                        </div>              
                    </div>
                    <div className="col-5 d-none d-sm-flex justify-content-center align-items-center">
                        <Swiper effect={'coverflow'} grabCursor={true} centeredSlides={true} slidesPerView={'auto'}
                            coverflowEffect={{ rotate: 30, stretch: 0, depth: 100, modifier: 1, slideShadows: false }}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            modules={[EffectCoverflow, Autoplay]} className="w-full mx-auto">
                            {projects.map((project, index) => (
                                <SwiperSlide key={index}>
                                    <Lottie animationData={project.animation} loop={true} autoplay={true} style={{ width: '100%', height: 'auto' }} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                  </div>
            </div>
        </section>
    );
}
